import { ReactComponent as BrSvg } from '../../../assets/br.svg'
import './styles.css'

export default function MapaBrasil({ estadoHover, onEstadoHover, ...props }) {
  function handleMouseOver(e) {
    const path = e.target.closest('path[id^="BR"]')
    if (path && onEstadoHover) {
      onEstadoHover(path.id.replace('BR', ''))
    }
  }

  function handleMouseOut(e) {
    const path = e.target.closest('path[id^="BR"]')
    if (path && onEstadoHover) {
      onEstadoHover(null)
    }
  }

  const hoverClass = estadoHover ? `hover-estado-BR${estadoHover}` : ''

  return (
    <div
      className={`mapa-brasil-container ${hoverClass}`}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      {...props}
    >
      <BrSvg className="mapa-brasil" />
    </div>
  )
}
